import React, { useState, useEffect } from 'react';
import { RadioButton } from '@volkswagen-onehub/components-core';
import { useDispatch, useSelector } from 'react-redux';
import { OneFormState } from 'src/types';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { useFormContext } from 'react-hook-form';
import { ctaEnvioCEM } from 'src/feature-app/InputsValues/CTAsObjects';



export const ChecksPublicacion = () => {
  const dispatch = useDispatch();
  const [firstCta, secondCta] = ctaEnvioCEM;
  const { concesion } = useSelector((state: OneFormState) => state.formData.fields);

  const [checkedOne, setCheckedOne] = useState(false);
  const [checkedTwo, setCheckedTwo] = useState(false);

  const { handleNextStep } = useOneFormContext();
  const [value, setValue] = useState(null);
  const { register } = useFormContext();

  const handleOnClick = (e: any) => {
    dispatch({ type: 'UPDATE_FIELDS', payload: { publicarRespuestas: e.currentTarget.value } });
    setTimeout(
      () => {
        handleNextStep();
      }, 0
    );
    
  };

  return (
    <div style={{ paddingTop: '42px' }}>
      <div style={{ paddingBottom: '20px', paddingLeft: '12px' }}>
        <RadioButton
          value={firstCta.value}
          label={firstCta.label.replace('[Concesionario]', concesion)}
          name="publicarRespuestas"
          onClick={(e) => {            
            setValue(firstCta.value);
            setCheckedOne(true);
            setCheckedTwo(false);
            handleOnClick(e);
          }}
          checked={checkedOne}
        />
      </div>
      <div style={{ paddingLeft: '12px' }}>
        <RadioButton
          value={secondCta.value}
          label={secondCta.label.replace('[Concesionario]', concesion)}
          name="publicarRespuestas"
          onClick={(e) => {            
            setValue(secondCta.value);
            setCheckedOne(false);
            setCheckedTwo(true);
            handleOnClick(e);
          }}
          checked={checkedTwo}
        />
      </div>
      <input
        type="hidden"
        name="publicarRespuestas"
        value={value}
        ref={register({
          required: {
            value: true,
            message: 'Requerido',
          },
        })}
      />
    </div>
  );
};
